import axios from 'axios'

const API_BASE_URL = 'http://localhost:13000/api/v1'

export interface PressureEquipment {
  id: string
  tenant_id: string
  equipment_type: string
  serial_number: string
  status: string
  location: string
  max_pressure?: number
  min_pressure?: number
  test_pressure?: number
  test_frequency_months?: number
  last_test_date?: string
  next_test_due?: string
  description?: string
  created_at: string
  updated_at: string
}

export interface CreatePressureEquipmentRequest {
  equipment_type: string
  serial_number: string
  status: string
  location: string
  max_pressure?: number
  min_pressure?: number
  test_pressure?: number
  test_frequency_months?: number
  last_test_date?: string
  description?: string
}

export interface PressureEquipmentListResponse {
  items: PressureEquipment[]
  total: number
  skip: number
  limit: number
}

class PressureEquipmentService {
  async listPressureEquipment(
    skip: number = 0,
    limit: number = 50,
    filters?: {
      status?: string
      location?: string
      equipment_type?: string
    }
  ): Promise<PressureEquipmentListResponse> {
    try {
      const params = new URLSearchParams()
      params.append('skip', String(skip))
      params.append('limit', String(limit))

      if (filters?.status) {
        params.append('status', filters.status)
      }
      if (filters?.location) {
        params.append('location', filters.location)
      }
      if (filters?.equipment_type) {
        params.append('equipment_type', filters.equipment_type)
      }

      const response = await axios.get(`${API_BASE_URL}/equipment/pressure-equipment?${params.toString()}`)
      return response.data
    } catch (error) {
      console.error('Error listing pressure equipment:', error)
      throw error
    }
  }

  async getPressureEquipment(id: string): Promise<PressureEquipment> {
    try {
      const response = await axios.get(`${API_BASE_URL}/equipment/pressure-equipment/${id}`)
      return response.data
    } catch (error) {
      console.error(`Error fetching pressure equipment ${id}:`, error)
      throw error
    }
  }

  async createPressureEquipment(data: CreatePressureEquipmentRequest): Promise<PressureEquipment> {
    try {
      const response = await axios.post(`${API_BASE_URL}/equipment/pressure-equipment`, data)
      return response.data
    } catch (error) {
      console.error('Error creating pressure equipment:', error)
      throw error
    }
  }

  async updatePressureEquipment(
    id: string,
    data: Partial<CreatePressureEquipmentRequest>
  ): Promise<PressureEquipment> {
    try {
      const response = await axios.put(`${API_BASE_URL}/equipment/pressure-equipment/${id}`, data)
      return response.data
    } catch (error) {
      console.error(`Error updating pressure equipment ${id}:`, error)
      throw error
    }
  }

  async deletePressureEquipment(id: string): Promise<void> {
    try {
      await axios.delete(`${API_BASE_URL}/equipment/pressure-equipment/${id}`)
    } catch (error) {
      console.error(`Error deleting pressure equipment ${id}:`, error)
      throw error
    }
  }
}

export const pressureEquipmentService = new PressureEquipmentService()
